import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  confirmationModalTitle: {
    defaultMessage: 'Configure Shipments in ShipStation',
    description: 'Title for the confirmation modal for creating shipments',
    id: 'zK6xgF',
  },
  inProgressModalTitle: {
    defaultMessage: 'Configuring Shipments in ShipStation',
    description: 'Title for the modal while shipments are being created',
    id: '+QjFym',
  },
  modalSuccessTitle: {
    defaultMessage: 'Shipments Successfully Configured',
    description: 'Title for the success modal after creating shipments',
    id: 'canJQs',
  },
  confirmationModalCloseButton: {
    defaultMessage: 'Close',
    description: 'Text for close button in modal',
    id: 'C3dAYJ',
  },
  goToOrderDetailsButton: {
    defaultMessage: 'Go to Order Details',
    description: 'Button to go to order details',
    id: '6A5cP4',
  },
  createOrdersButton: {
    defaultMessage: 'Create Order & Shipments',
    description: 'Button text to trigger order and shipment creation',
    id: 'hx9AuH',
  },
  noActiveManualStoreError: {
    defaultMessage: 'You need an active manual store to configure shipments for an ASN',
    description: 'Error message shown when there are no active manual stores available',
    id: 'rR6ezk',
  },
});
